<template>
  <div class="App-Tradelaw bg-white">
    <div class="inner inner-middle text-center">
      <h1 class="h1 title">{{$t('tradelaw.title')}}</h1>
      <div class="content text-left">
        <div class="title-mini">{{$t('tradelaw.title1')}}</div>
        <div class="text">{{$t('tradelaw.text1')}}</div>
        <div class="title-mini">{{$t('tradelaw.title2')}}</div>
        <div class="text">{{$t('tradelaw.text2')}}</div>
        <div class="title-mini">{{$t('tradelaw.title3')}}</div>
        <div class="text white-space-pre-wrap">{{$t('tradelaw.text3')}}</div>
        <!-- <div class="title-mini">{{$t('tradelaw.title')}}</div>
        <div class="text">{{$t('tradelaw.text')}}</div> -->
        <div class="title-mini">{{$t('tradelaw.title5')}}</div>
        <div class="text">
          <router-link :to="{name: 'contact.index'}">{{$t('tradelaw.text5')}}</router-link>
        </div>
        <div class="title-mini">{{$t('tradelaw.title6')}}</div>
        <div class="text">{{$t('tradelaw.text6')}}</div>
        <div class="title-mini">{{$t('tradelaw.title7')}}</div>
        <div class="text white-space-pre-wrap">{{$t('tradelaw.text7')}}</div>
        <div class="title-mini">{{$t('tradelaw.title8')}}</div>
        <div class="text white-space-pre-wrap">{{$t('tradelaw.text8')}}</div>
        <div class="title-mini">{{$t('tradelaw.title9')}}</div>
        <div class="text white-space-pre-wrap">{{$t('tradelaw.text9')}}</div>
        <div class="title-mini">{{$t('tradelaw.title10')}}</div>
        <div class="text white-space-pre-wrap">{{$t('tradelaw.text10')}}</div>
        <div class="title-mini">{{$t('tradelaw.title11')}}</div>
        <div class="text white-space-pre-wrap">{{$t('tradelaw.text11')}}</div>
        <div class="title-mini">{{$t('tradelaw.title12')}}</div>
        <div class="text white-space-pre-wrap last">{{$t('tradelaw.text12')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { META_TRADELAW } from '../../mixins/metadata.js'

  export default {
    mixins: [META_TRADELAW],
    name: 'Tradelaw',
    head: {
      title: {
        inner: '特定商取引法に基づく表示｜ZATSUDAN'
      },
      meta: [
        { name: 'keywords', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
        { name: 'description', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
      ]
    },
  }
</script>
